import { render, staticRenderFns } from "./periodForm.vue?vue&type=template&id=3f15c7de&scoped=true"
import script from "./periodForm.vue?vue&type=script&lang=ts"
export * from "./periodForm.vue?vue&type=script&lang=ts"
import style0 from "./periodForm.vue?vue&type=style&index=0&id=3f15c7de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f15c7de",
  null
  
)

export default component.exports